import React, { createContext, useContext } from 'react';

import { type ProgressiveFieldAddRevealResult } from './use-progressive-field-add-reveal.ts';

const ProgressiveFieldAddRevealContext = createContext<
  ProgressiveFieldAddRevealResult | undefined
>(undefined);

export function ProgressiveFieldAddRevealProvider({
  children,
  result
}: {
  children: React.ReactNode;
  result: ProgressiveFieldAddRevealResult;
}) {
  return (
    <ProgressiveFieldAddRevealContext.Provider value={result}>
      {children}
    </ProgressiveFieldAddRevealContext.Provider>
  );
}

export function useProgressiveFieldAddRevealContext():
  | ProgressiveFieldAddRevealResult
  | undefined {
  return useContext(ProgressiveFieldAddRevealContext);
}
